import {createSlice} from '@reduxjs/toolkit';
import {appModes} from './constants';

const initialState = {
    mode: appModes.APP_MODE_NORMAL,
};

export default createSlice({
    name: 'app',
    initialState,
    reducers: {
        setAppMode: (state, action) => {
            state.mode = action.payload;
        },
    },
});